/**
 * Inject Cloudinary transformation parameters into a Cloudinary image URL.
 * Non-Cloudinary URLs are returned unchanged.
 *
 * Default transforms:
 *   q_auto   — auto quality (Cloudinary picks the best level, ~60-80% size reduction)
 *   f_auto   — auto format (serves WebP/AVIF to browsers that support it)
 *   w_{width} — resize to the requested width (default 800px)
 */
export const clImg = (url, { width = 800 } = {}) => {
  if (!url || !url.includes("res.cloudinary.com")) return url;
  // Already has transforms — don't double-apply
  if (url.includes("q_auto")) return url;
  return url.replace("/upload/", `/upload/q_auto,f_auto,w_${width}/`);
};

/** Tiny blurred placeholder (20px wide) for blur-up effect while the real image loads. */
export const clThumb = (url) => {
  if (!url || !url.includes("res.cloudinary.com")) return null;
  if (url.includes("q_auto")) return null;
  return url.replace("/upload/", "/upload/q_10,f_auto,w_20,e_blur:200/");
};
